module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"identifier":"Identifier","registerTree":"Register Tree","health":"Health"},"es":{"identifier":"Identificador","registerTree":"Árbol de registro","health":"Salud"},"sw":{"identifier":"Kitambulisho","registerTree":"Sajili Mti","health":"Afya"}}')
  delete Component.options._Ctor
}
